import React, { useCallback, useEffect, useState } from "react";
import { Input } from "reactstrap";
import { Button, Modal } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { toast } from "react-toastify";
import API from "../../../utils";
import axios from "axios";
import debounce from 'lodash.debounce';

const FACe = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const uid = localStorage.getItem("user_id");
  const [formData, setFormData] = useState({
    name_of_function: "",
    person_accountable: [],
    leading_indicators: "",
    results_outcomes: "",
  });
  const [updatedTask, setUpdatedTask] = useState(null);
  const [AffirmationEntries, setAffirmationEntries] = useState([]);

  const [isPersonAccountableModalOpen, setIsPersonAccountableModalOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append('user_id', uid);

    try {
      const response = await axios.post(
        `${API.BASE_URL}${API.ENDPOINTS.get_all_functional_accountability_chart}`,
        formDataToSend,
        {
          headers: {
            Authorization: `${API.AUTHORIZATION_TOKEN}`,
          },
        }
      );

      if (response.data.status === 'success') {
        const sortedTasks = response.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setAffirmationEntries(sortedTasks);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error during task fetching:', error);
      toast.error("An error occurred while fetching tasks.");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('user_id', uid);
    formDataToSend.append('name_of_function', String(formData.name_of_function));
    formDataToSend.append('person_accountable', JSON.stringify(formData.person_accountable));
    formDataToSend.append('leading_indicators', String(formData.leading_indicators));
    formDataToSend.append('results_outcomes', String(formData.results_outcomes));
    try {
      const response = await axios.post(
        `${API.BASE_URL}${API.ENDPOINTS.add_functional_accountability_chart}`,
        formDataToSend,
        {
          headers: {
            Authorization: `${API.AUTHORIZATION_TOKEN}`,
          },
        }
      );

      if (response.data.status === "success") {
        toast.success("FACe Added Successfully");
        fetchTasks();
        setFormData({
          name_of_function: "",
          person_accountable: [],
          leading_indicators: "",
          results_outcomes: "",
        });

      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error during task submission:", error);
      toast.error("An error occurred during submission.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormRadioChange = (e) => {
    const { value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      person_accountable: value,
    }));
  };



  const isSaveButtonEnabled = () =>
    formData.name_of_function.trim() !== ''

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredEntries = AffirmationEntries.filter(entry =>
    entry.name_of_function && entry.name_of_function.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const debouncedUpdateTask = useCallback(
    debounce(async (task) => {
      const formDataToSend = new FormData();
      formDataToSend.append('functional_id', task.id);
      formDataToSend.append('field', task.field);
      formDataToSend.append('text', task.value);

      try {
        const response = await axios.post(
          `${API.BASE_URL}${API.ENDPOINTS.update_functional_accountability_chart}`,
          formDataToSend,
          {
            headers: {
              Authorization: `${API.AUTHORIZATION_TOKEN}`,
            },
          }
        );

        if (response.data.status === "success") {
          toast.success("FACe Updating Successfully");
          fetchTasks();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("An error occurred while updating data.");
      }
    }, 2000),
    []
  );

  const handleEditInputChange = (e, index, field, id, isCheckbox = false, checkboxValue = '') => {
    const updatedEntries = [...AffirmationEntries];
    const entry = updatedEntries[index];

    if (isCheckbox) {
      const personAccountable = Array.isArray(entry[field]) ? entry[field] : [];

      if (checkboxValue === undefined || checkboxValue === null) {
        console.error('Checkbox value is undefined or null');
        return;
      }

      if (personAccountable.includes(checkboxValue)) {
        entry[field] = personAccountable.filter(item => item !== checkboxValue);
      } else {
        entry[field] = [...personAccountable, checkboxValue];
      }
    } else {
      entry[field] = String(e.target.value);
    }

    setAffirmationEntries(updatedEntries);

    setUpdatedTask({
      id,
      field,
      value: entry[field]
    });
  };

  useEffect(() => {
    if (updatedTask) {
      debouncedUpdateTask(updatedTask);
    }
  }, [updatedTask, debouncedUpdateTask]);

  const closePersonAccountableModal = () => {
    setIsPersonAccountableModalOpen(false);
    setCurrentRow(null);
  };

  const handleModalCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (currentRow) {
      const personAccountable = Array.isArray(currentRow.person_accountable)
        ? currentRow.person_accountable
        : [];

      const isAlreadyChecked = personAccountable.includes(value);
      const shouldUpdate = (checked && !isAlreadyChecked) || (!checked && isAlreadyChecked);

      if (shouldUpdate) {
        const updatedPersonAccountable = checked
          ? [...personAccountable, value]
          : personAccountable.filter(item => item !== value);

        setCurrentRow({
          ...currentRow,
          person_accountable: updatedPersonAccountable,
        });

        const updatedEntries = [...AffirmationEntries];
        updatedEntries[currentRow.index].person_accountable = updatedPersonAccountable;
        setAffirmationEntries(updatedEntries);

        setUpdatedTask({
          id: currentRow.id,
          field: "person_accountable",
          value: updatedPersonAccountable,
        });
      }
    }
  };

  const columns = [
    {
      name: 'Name Of Function',
      selector: row => row.name_of_function,
      cell: (row, index) => (
        <div className="businessroles-table w-100">
          <select
            className="form-control"
            name="name_of_function"
            value={row.name_of_function}
            onChange={(e) => handleEditInputChange(e, index, "name_of_function", row.id)}
            type="select"
          >
            <option value="">Choose Option</option>
            <option value="Head of Company">Head of Company</option>
            <option value="Marketing">Marketing</option>
            <option value="R&D/Innovation">R&D/Innovation</option>
            <option value="Sales">Sales</option>
            <option value="Operations">Operations</option>
            <option value="Treasury">Treasury</option>
            <option value="IT/Technology">IT/Technology</option>
          </select>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Leading Indicators (Key Performance Indicators)',
      selector: row => row.leading_indicators,
      cell: (row, index) => (
        <div className="businessroles-table w-100">
          <input
            type="text"
            value={row.leading_indicators}
            className="form-control"
            name="leading_indicators"
            onChange={(e) => handleEditInputChange(e, index, "leading_indicators", row.id)}
          />
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Results/Outcomes (P/L or B/S Items)',
      selector: row => row.results_outcomes,
      cell: (row, index) => (
        <div className="businessroles-table w-100">
          <input
            type="text"
            value={row.results_outcomes}
            name="results_outcomes"
            className="form-control"
            onChange={(e) => handleEditInputChange(e, index, "results_outcomes", row.id)}
          />
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Person Accountable',
      selector: row => row.person_accountable,
      cell: (row, index) => (
        <div className="businessroles-table w-100">
          <span>{row.person_accountable.replace(/['"]+/g, '')}</span>
        </div>
      ),
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className=" align-items-center justify-content-between d-flex">
                  <h5>Functionality Accountability Chart (FACe)</h5>
                </div>
              </div>
            </div>

            <div className="card-body">

              <div className="founderdriers mb-3">
                <p className="textnots-text">
                  <strong>Functional Accountability Chart(FACe)</strong>
                </p>
                <p className="textnots-text">
                  <span className="textnote-span-one">1.</span>
                  Name the person accountable for each function
                </p>
                <p className="textnots-text">
                  <span className="textnote-span-one">2.</span>
                  Ask the four questions at the bottom of the page re: whose name(s) you listed for each function
                </p>
                <p className="textnots-text">
                  <span className="textnote-span-one">3.</span>
                  List Key Performance Indicators (KPIs) for each function
                </p>
                <p className="textnots-text">
                  <span className="textnote-span-one">4.</span>
                  Take your Profit and Loss (P/L), Balance Sheet (B/S), and Cash Flow accounting statements and assign a person to each line item, then derive appropriate Results/Outcomes for each function
                </p>
              </div>

              <form className="theme-form">
                <div className="row">
                  <div className="form-group mb-3 col-lg-4 col-md-6">
                    <label><b>Name Of Function</b></label>
                    <Input
                      className="form-control"
                      name="name_of_function"
                      value={formData.name_of_function}
                      onChange={handleInputChange}
                      type="select"
                    >
                      <option value="">Choose Option</option>
                      <option value="Head of Company">Head of Company</option>
                      <option value="Marketing">Marketing</option>
                      <option value="R&D/Innovation">R&D/Innovation</option>
                      <option value="Sales">Sales</option>
                      <option value="Operations">Operations</option>
                      <option value="Treasury">Treasury</option>
                      <option value="IT/Technology">IT/Technology</option>
                    </Input>
                  </div>

                  <div className="form-group mb-3 col-lg-4 col-md-6">
                    <label><b>Leading Indicators (Key Performance Indicators)</b></label>
                    <Input
                      className="form-control"
                      name="leading_indicators"
                      value={formData.leading_indicators}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group mb-3 col-lg-4 col-md-6">
                    <label><b>Results/Outcomes (P/L or B/S Items)</b></label>
                    <Input
                      className="form-control"
                      name="results_outcomes"
                      value={formData.results_outcomes}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label><b>Person Accountable</b></label>
                    {["More than 1 Person in a Seat", "Person in more than 1 seat", "Seat has No one accountable", "Person lacks skill/experience"].map((label) => (
                      <div key={label}>
                        <label><b>
                          <input
                            type="radio"
                            className="radio_animated radio-primary"
                            name="person_accountable"
                            value={label}
                            checked={formData.person_accountable === label}
                            onChange={handleFormRadioChange}
                            aria-label={label}
                          />
                          {label}
                        </b></label>
                      </div>
                    ))}
                  </div>

                </div>
                <div className="d-flex justify-content-end align-content-center mb-2">
                  <Button variant="success" onClick={handleSubmit} disabled={!isSaveButtonEnabled()}>Save</Button>
                </div>
              </form>

              <div className="row">
                <div className="col-md-9"></div>
                <div className="col-md-3">
                  <div className="form-group text-end mb-3">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>
              </div>

              <DataTable
                columns={columns}
                data={filteredEntries}
                pagination
                persistTableHead={true}
              />

              {/* Person Accountable Modal */}
              <Modal show={isPersonAccountableModalOpen} onHide={closePersonAccountableModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Person Accountable</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {["More than 1 Person in a Seat", "Person in more than 1 seat", "Seat has No one accountable", "Person lacks skill/experience"].map((value) => (
                    <div key={value}>
                      <label>
                        <input
                          className="checkbox_animated"
                          type="checkbox"
                          value={value}
                          checked={currentRow?.person_accountable.includes(value)}
                          onChange={handleModalCheckboxChange}
                        />
                        {value}
                      </label>
                    </div>
                  ))}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={closePersonAccountableModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FACe;
